import React, { useState } from 'react';

export const SchoolBasicInfo = () => {
    const [phone, setPhone] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [isSame, setIsSame] = useState(false);

    const handlePhoneChange = (e) => {
        const val = e.target.value;
        setPhone(val);
        if (isSame) {
            setWhatsapp(val);
        }
    };

    const handleSameToggle = (e) => {
        const checked = e.target.checked;
        setIsSame(checked);
        if (checked) {
            setWhatsapp(phone);
        }
    };

    return (
        <div className="enquiry-section">
            {/* Hidden Form Values required by backend */}
            <input type="hidden" name="gender" value="others" />
            <input type="hidden" name="qualification" value="default" />

            <div className="d-flex align-items-center gap-2 mb-2">
                <span className="section-title-badge bg-soft-success text-success">
                    <i className="ri-building-line me-1"></i>Basic Information
                </span>
            </div>

            <div className="row g-3">
                {/* School Name */}
                <div className="col-12 col-md-6">
                    <label htmlFor="enquiryName" className="form-label form-label-custom">
                        <i className="ri-community-line text-muted me-1"></i>
                        School Name <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        className="form-control form-control-custom"
                        id="enquiryName"
                        name="name"
                        placeholder="e.g. Oxford Public School"
                        required
                    />
                </div>

                {/* Principal Name */}
                <div className="col-12 col-md-6">
                    <label htmlFor="enquiryFatherName" className="form-label form-label-custom">
                        <i className="ri-user-star-line text-muted me-1"></i>
                        Principal Name
                    </label>
                    <input
                        type="text"
                        className="form-control form-control-custom"
                        id="enquiryFatherName"
                        name="father_name"
                        placeholder="Enter Principal Name"
                    />
                </div>

                {/* Phone Number */}
                <div className="col-12 col-md-6">
                    <label htmlFor="phoneNumber" className="form-label form-label-custom">
                        <i className="ri-phone-line text-muted me-1"></i>
                        Phone Number <span className="text-danger">*</span>
                    </label>
                    <input
                        type="tel"
                        className="form-control form-control-custom"
                        name="phone"
                        id="phoneNumber"
                        placeholder="Enter 10-digit phone number"
                        value={phone}
                        onChange={handlePhoneChange}
                        required
                    />
                </div>

                {/* WhatsApp Number with Same-as Checkbox */}
                <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <label htmlFor="whatsappNumber" className="form-label form-label-custom mb-0">
                            <i className="ri-whatsapp-line text-success me-1"></i>
                            WhatsApp Number
                        </label>
                        <div className="form-check form-check-inline mb-0">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="samewhatsapp"
                                checked={isSame}
                                onChange={handleSameToggle}
                            />
                            <label className="form-check-label fs-12 text-muted cursor-pointer" htmlFor="samewhatsapp">
                                Same as Phone
                            </label>
                        </div>
                    </div>
                    <input
                        type="tel"
                        className="form-control form-control-custom"
                        name="whatsapp"
                        id="whatsappNumber"
                        placeholder="Enter WhatsApp number"
                        value={whatsapp}
                        onChange={(e) => setWhatsapp(e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
};

export default SchoolBasicInfo;
